import { QueryClient } from '@tanstack/react-query';
import { isAxiosError } from 'axios';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,          // 30 seconds
      gcTime: 5 * 60 * 1000,     // 5 minutes
      retry: (failureCount, error) => {
        // Retrying a 429 just adds to the request burst that triggered it —
        // let it back off via staleTime/refetchInterval instead.
        if (isAxiosError(error) && error.response?.status === 429) return false;
        return failureCount < 2;
      },
      retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 10_000),
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 0,
    },
  },
});
